var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNotifications = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.455,
    height: 24.545,
    viewBox: "0 0 20.455 24.545",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notifications",
    transform: "translate(-67.5 -984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M63.04,91.791l-1.757-2.927a8.7,8.7,0,0,1-1.239-4.473V81.826a7.159,7.159,0,0,0-14.318,0V84.39a8.7,8.7,0,0,1-1.239,4.473L42.73,91.791a.511.511,0,0,0,.439.774H62.6a.511.511,0,0,0,.439-.774Zm-18.967-.249,1.292-2.153a9.714,9.714,0,0,0,1.385-5V81.826a6.136,6.136,0,0,1,12.273,0V84.39a9.723,9.723,0,0,0,1.384,5L61.7,91.542H44.072Z",
    transform: "translate(24.843 912.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M215.378,0a2.048,2.048,0,0,0-2.045,2.045V4.091a.511.511,0,0,0,1.023,0V2.045a1.023,1.023,0,0,1,2.045,0V4.091a.511.511,0,0,0,1.023,0V2.045A2.048,2.048,0,0,0,215.378,0Z",
    transform: "translate(-137.651 984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M207.436,426.932a.512.512,0,0,0-.884.518,1.534,1.534,0,1,1-2.657,0,.512.512,0,0,0-.884-.518,2.558,2.558,0,1,0,4.424,0Z",
    transform: "translate(-127.495 577.776)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotifications, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notifications.6ec63ef1.svg";
export { ForwardRef as ReactComponent };